import {CommonModule} from '@angular/common';
import {Component, inject, Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {RoleAssignmentUserLookupDto} from '../../../models/generated-models';
import {userRoleLabel} from '../../app.constants';

@Component({
  selector: 'app-role-assign-user-select-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './role-assign-user-select-modal.html',
  styleUrl: './role-assign-user-select-modal.scss',
})
export class RoleAssignUserSelectModal {
  @Input() users: RoleAssignmentUserLookupDto[] = [];

  protected readonly activeModal = inject(NgbActiveModal);
  protected readonly userRoleLabel = userRoleLabel;
  private readonly avatarErrors = new Set<string | number>();

  hasAvatarError(id: string | number): boolean {
    return this.avatarErrors.has(id);
  }

  onAvatarError(id: string | number): void {
    this.avatarErrors.add(id);
  }

  selectUser(user: RoleAssignmentUserLookupDto): void {
    if (user.invitationAccepted) {
      return;
    }
    this.activeModal.close(user);
  }

  cancel(): void {
    this.activeModal.dismiss('cancel');
  }
}
